import React from "react";
import classnames from "classnames";
import Price from "Shared/Price";
import Button from "Shared/Button";
import { addToCart, reloadCart } from "./../../Cart/action-creators";
import { quantityIncludingSubdeliveries } from "../../Cart/reducer";
import { loadCheckout } from "./../../Checkout/action-creators";
import { toggleMiniCart } from "./../MiniCart/action-creators";
import { translate } from "Shared/translate";
import Icon from "Shared/Icon";
import { SMALL } from "Shared/breakpoints";
import connect from "Shared/connect";
import { checkoutPageUrl } from "Shared/known-urls";
import FeedbackButton from "Shared/Button/Feedback";
import DesktopCartHeader from "./Header";
import MiniCartContainer from "./MiniCartContainer";
import { ProductCardSelectionProvider } from "Shared/ProductComponents/ProductCardSelection";
import * as styles from "./base.scss";
import { updateODPTrackingMinicart } from "./../../TrackingInformation";
import ProductCardItem from "Shared/ProductCard/ProductRow2.0/ProductCardItem";
import { pushState } from "Shared/history";
class MiniCart extends React.PureComponent {
    constructor(props) {
        super(props);
        this.isItemPending = (item) => {
            if (!this.props.cart.pendingChanges) {
                return false;
            }
            return this.props.cart.pendingChanges.some((change) => !!change.items[item.lineItem.code]);
        };
        this.state = { setCartItemScroll: false };
    }
    componentDidMount() {
        updateODPTrackingMinicart();
    }
    componentWillUnmount() {
        this.unbindResizeListener && this.unbindResizeListener();
    }
    fetchCheckoutDataAndGoToCheckoutPage(resolve) {
        this.props.loadCheckout();
        pushState(checkoutPageUrl().url);
        resolve();
    }
    getFilteredAndSortedCartItems() {
        return this.props.cart.items.filter((i) => quantityIncludingSubdeliveries(i.lineItem) > 0);
    }
    render() {
        const cartItems = this.getFilteredAndSortedCartItems();
        const isMobile = this.props.currentBreakpoint < SMALL;
        const selectableProductIndexes = cartItems.map(({}, index) => index);
        return (React.createElement("div", { ref: (ref) => (this.rootElement = ref), className: classnames(styles.base, {
                [styles.flyout]: this.props.isFlyout,
            }), onClick: (e) => e.stopPropagation() },
            React.createElement("div", { className: classnames(styles.body, styles.scroll, {
                    [styles.scroll]: this.props.isFlyout,
                }) }, cartItems.length > 0 ? (!isMobile ? (React.createElement("div", { ref: (ref) => (this.tableList = ref) },
                React.createElement(DesktopCartHeader, null),
                React.createElement("div", { className: styles.main },
                    React.createElement(ProductCardSelectionProvider, { selectableIndexes: selectableProductIndexes },
                        React.createElement("div", { className: classnames(styles.cartItemSection, styles.grid, styles.isCart), "data-list-type": "viewLayout_List" }, cartItems.map((item, index) => (React.createElement(MiniCartContainer, { key: item.lineItem.code, cartItem: item, index: index }, ({ cartItem, quantityInCart, selectedVariant, updateCartQuantity, removeCartItem, quantityStep, url, }) => (React.createElement(React.Fragment, null,
                            React.createElement(ProductCardItem, { product: cartItem.product, quantityInCart: quantityInCart, selectedVariant: selectedVariant, updateCartQuantity: updateCartQuantity, discontinuedOrBackordered: false, quantityStep: quantityStep, index: index, url: url, isRestrictedCustomer: false, cardType: "viewLayout_List", isCart: true, totalPrice: item.lineItem.totalPrice, removeCartItem: removeCartItem }))))))))),
                React.createElement("div", { className: classnames(styles.tablefooter, styles.summary) },
                    React.createElement("div", { className: styles.removePlaceholder }),
                    React.createElement(FeedbackButton, { appearance: "large", onClickWithFeedback: (e, activate) => activate(new Promise((resolve, reject) => this.fetchCheckoutDataAndGoToCheckoutPage(resolve))), disabled: !this.props.cart.items.length, "data-ta": "to-checkout-button" }, translate("/MiniCart/ToCheckout")),
                    React.createElement("div", { className: styles.priceSummary }, !this.props.isSupplierSalesman && (React.createElement(React.Fragment, null,
                        React.createElement("span", { className: styles.toPayText },
                            translate("/MiniCart/ToPay"),
                            ":"),
                        React.createElement(Price, Object.assign({}, this.props.cart.subTotal, { 
                            //eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                            //@ts-ignore
                            size: "huge", isPending: this.props.cart.isLoading })))))))) : (React.createElement("div", null,
                React.createElement("div", { className: styles.mobileTopWrapper },
                    React.createElement("div", { className: styles.top },
                        React.createElement("div", { className: styles.close },
                            React.createElement(Button, { appearance: "secondary", onClick: () => this.props.toggleMiniCart() },
                                React.createElement(Icon, { name: "header-close" }))),
                        React.createElement("span", null, translate("/Checkout/Heading"))),
                    React.createElement("div", { className: styles.total },
                        React.createElement("div", { className: styles.sumWrap }, !this.props.isSupplierSalesman && (React.createElement(React.Fragment, null,
                            React.createElement("div", null,
                                translate("/MiniCart/ToPay"),
                                ":"),
                            React.createElement(Price, Object.assign({ className: styles.sum }, this.props.cart.subTotal, { 
                                //eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                                //@ts-ignore
                                size: "huge", isPending: this.props.cart.isLoading }))))),
                        React.createElement(FeedbackButton, { appearance: "full", onClickWithFeedback: (e, activate) => {
                                return activate(new Promise((resolve, reject) => {
                                    this.fetchCheckoutDataAndGoToCheckoutPage(resolve);
                                }));
                            }, disabled: !this.props.cart.items.length, "data-ta": "to-checkout-button" }, translate("/MiniCart/ToCheckout")))),
                React.createElement("div", { className: styles.main },
                    React.createElement(ProductCardSelectionProvider, { selectableIndexes: selectableProductIndexes },
                        React.createElement("div", { className: classnames(styles.mobileBottomWrapper, styles.grid, styles.isCart), "data-list-type": "viewLayout_List" }, cartItems.map((item, index) => (React.createElement(MiniCartContainer, { key: item.lineItem.code, cartItem: item, index: index }, ({ cartItem, quantityInCart, selectedVariant, updateCartQuantity, removeCartItem, quantityStep, url, }) => (React.createElement(React.Fragment, null,
                            React.createElement(ProductCardItem, { product: cartItem.product, quantityInCart: quantityInCart, selectedVariant: selectedVariant, updateCartQuantity: updateCartQuantity, discontinuedOrBackordered: false, quantityStep: quantityStep, index: index, url: url, isRestrictedCustomer: false, cardType: "viewLayout_List", isCart: true, totalPrice: item.lineItem.totalPrice, removeCartItem: removeCartItem })))))))))))) : (React.createElement("div", null,
                React.createElement("div", { className: styles.close }, isMobile && (React.createElement(Button, { appearance: "clear", onClick: () => this.props.toggleMiniCart() },
                    React.createElement(Icon, { name: "close" })))),
                React.createElement("p", { className: styles.empty }, translate("/MiniCart/EmptyCart")))))));
    }
}
export default connect((state) => ({
    cart: state.cart,
    miniCartIsOpen: state.miniCart.isOpen,
    currentBreakpoint: state.currentBreakpoint,
    isSupplierSalesman: state.currentUser.isSupplierSalesman,
}), (dispatch) => ({
    toggleMiniCart: (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        dispatch(toggleMiniCart());
    },
    reloadCart() {
        dispatch(reloadCart());
    },
    loadCheckout() {
        return dispatch(loadCheckout());
    },
    updateCartItemQuantity: (code, quantity, date, unitShortName, ticket) => dispatch(addToCart(code, quantity, unitShortName, ticket, "MiniCart")),
}))(MiniCart);
